<template>
  <div class="content">
    <div class="content_title">
      Связь групп доступа и посёлков
    </div>
    <div v-show="!data_loaded">
      <button @click="getParsecData">Загрузить данные</button>
    </div>
    <div v-show="data_loaded" class="content_row" style="align-items: normal;">
      <div style="display: block;">
        <div>Группа доступа</div>
        <label><input v-model="access_group_filter"/></label>
        <div style="display: block;">
          <div
            style="display: block;"
            v-for="(group, key) in parsecGroups"
            class="checkboxes"
            v-show="!group.hide"
          >
            <input
              type="checkbox"
              :id="'g_' + group.PARSEC_ID"
              v-bind:value="group.PARSEC_ID"
              v-model="checkedGroups"
            />
            <label :for="'g_' + group.PARSEC_ID">{{ group.NAME }}</label>
          </div>
        </div>
      </div>
      <div style="display: block;">
        <div>Посёлки</div>
        <label><input v-model="village_filter"/></label>
        <div style="display: block;">
          <div
            v-for="(village, key) in villages"
            class="checkboxes"
            v-show="!village.hide"
          >
            <input
              type="checkbox"
              :id="'s_' + village.ID"
              v-bind:value="village.ID"
              v-model="checkedVillages"
            />
            <label :for="'s_' + village.ID">{{ village.NAME }}</label>
          </div>
        </div>
      </div>
      <div>
        <button @click="updateGroups">Сохранить</button>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "ParsecAccessLink",
  props: {
    updateList: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      url: config.backend_url,
      detailUrl: "",
      access_group_filter: "",
      village_filter: "",
      parsecGroups: [],
      villages: [],
      checkedGroups: [],
      checkedVillages: [],
      login: "",
      password: "",
      server_ip: "",
      data_loaded: false
    };
  },
  computed: {},
  watch: {
    access_group_filter: function(value) {
      for (var key in this.parsecGroups) {
        if (value) {
          if (this.parsecGroups[key].NAME.includes(value)) {
            this.parsecGroups[key].hide = false;
          } else {
            this.parsecGroups[key].hide = true;
          }
        } else {
          this.parsecGroups[key].hide = false;
        }
      }
    },
    village_filter: function(value) {
      for (var key in this.villages) {
        if (value) {
          if (this.villages[key].NAME.includes(value)) {
            this.villages[key].hide = false;
          } else {
            this.villages[key].hide = true;
          }
        } else {
          this.villages[key].hide = false;
        }
      }
    }
  },
  methods: {
    getParsecData: function() {
      let self = this;
      let user = this.$store.getters["user/getProfile"];
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "parsecgroups/get-link-data/",
          data: { user_id: user.id },
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.parsecGroups = data.groups;
            self.villages = data.villages;
            self.data_loaded = true;
          }
        });
    },
    updateGroups: function() {
      let self = this;
      let user = this.$store.getters["user/getProfile"];
      let updateData = {
        checked_groups: self.checkedGroups,
        checked_villages: self.checkedVillages,
        groups: self.parsecGroups,
        user_id: user.id
      };
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "parsecgroups/update-multi/",
          data: updateData,
          method: "POST"
        })
        .then(function() {
          let new_groups = [];
          self.parsecGroups.forEach(function(value) {
            if (!self.checkedGroups.includes(value.PARSEC_ID)) {
              new_groups.push(value);
            }
          });
          self.checkedGroups = [];
          self.checkedVillages = [];
          self.parsecGroups = new_groups;
          self.$emit("groups-updated");
        });
    }
  },
  created() {
    this.detailUrl = this.$route.fullPath;
  }
};
</script>
